import Vue from 'vue'
import VueI18n from 'vue-i18n'
import ElementLocale from 'element-ui/lib/locale'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import enLocale from 'element-ui/lib/locale/lang/en'
import zh from './zh'
import en from './en'

Vue.use(VueI18n)

const messages = {
  zh: {
    ...zh,
    ...zhLocale
  },
  en: {
    ...en,
    ...enLocale
  }
}

// 从localStorage获取语言设置，默认中文
const savedLanguage = localStorage.getItem('language') || 'zh'

const i18n = new VueI18n({
  locale: savedLanguage,
  fallbackLocale: 'zh',
  messages
})

// 配置Element UI使用vue-i18n
ElementLocale.i18n((key, value) => i18n.t(key, value))

export default i18n
